/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
/* =========================================
   SUGAR & SPIZE — SAFE MOBILE ACCORDION
   ========================================= */

document.addEventListener('DOMContentLoaded', function () {

  const MOBILE_MAX = 749;


  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }


  function getDirectPanel(sliderule) {

    if (!sliderule) return null;

    return Array.from(sliderule.children).find(function (child) {

      return (
        child.classList &&
        child.classList.contains('mobile__menu__dropdown') &&
        child.classList.contains('sliderule__panel')
      );

    }) || null;

  }


  function getWrapper(sliderule) {

    if (!sliderule) return null;

    return sliderule.closest('.sliderule__wrapper');

  }


  function hideSiblingItems(sliderule) {

    const wrapper = getWrapper(sliderule);

    if (!wrapper) return;

    const parent = wrapper.parentElement;

    if (!parent) return;


    Array.from(parent.children).forEach(function (child) {

      if (child === wrapper) return;


      if (
        child.classList &&
        (
          child.classList.contains('sliderule__wrapper') ||
          child.classList.contains('sliderow')
        )
      ) {

        child.classList.add('ss-accordion-hidden');

      }

    });

  }


  function showSiblingItems(sliderule) {

    const wrapper = getWrapper(sliderule);

    if (!wrapper) return;

    const parent = wrapper.parentElement;

    if (!parent) return;


    Array.from(parent.children).forEach(function (child) {

      if (child.classList) {
        child.classList.remove('ss-accordion-hidden');
      }

    });

  }


  function resetChildren(sliderule) {

    if (!sliderule) return;


    sliderule
      .querySelectorAll('mobile-sliderule.ss-accordion-open')
      .forEach(function (childSliderule) {

        childSliderule.classList.remove(
          'ss-accordion-open'
        );


        const childTrigger =
          Array.from(childSliderule.children).find(function (child) {

            return (
              child.matches &&
              child.matches('[data-sliderule-open]')
            );

          });


        if (childTrigger) {
          childTrigger.setAttribute(
            'aria-expanded',
            'false'
          );

          childTrigger.classList.remove(
            'ss-arrow-open'
          );
        }

      });


    sliderule
      .querySelectorAll('.ss-accordion-hidden')
      .forEach(function (item) {

        item.classList.remove(
          'ss-accordion-hidden'
        );

      });

  }


  function openAccordion(sliderule, trigger) {

    const panel = getDirectPanel(sliderule);

    if (!panel) return;


    hideSiblingItems(sliderule);


    sliderule.classList.add(
      'ss-accordion-open'
    );


    trigger.setAttribute(
      'aria-expanded',
      'true'
    );


    /* Arrow state only */
    trigger.classList.add(
      'ss-arrow-open'
    );

  }


  function closeAccordion(sliderule, trigger) {

    sliderule.classList.remove(
      'ss-accordion-open'
    );


    trigger.setAttribute(
      'aria-expanded',
      'false'
    );


    /* Arrow state only */
    trigger.classList.remove(
      'ss-arrow-open'
    );


    resetChildren(sliderule);


    showSiblingItems(sliderule);

  }


  document.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;


      const trigger = event.target.closest(
        '.drawer--header [data-sliderule-open]'
      );


      if (!trigger) return;


      const sliderule = trigger.closest(
        'mobile-sliderule'
      );


      if (!sliderule) return;


      const panel = getDirectPanel(sliderule);


      if (!panel) return;


      event.preventDefault();
      event.stopPropagation();


      if (
        sliderule.classList.contains(
          'ss-accordion-open'
        )
      ) {

        closeAccordion(
          sliderule,
          trigger
        );

      } else {

        openAccordion(
          sliderule,
          trigger
        );

      }

    },
    true
  );


  document.addEventListener(
    'click',
    function (event) {

      const closeButton = event.target.closest(
        '.drawer--header .drawer__close'
      );


      if (!closeButton) return;


      const drawer = closeButton.closest(
        '.drawer--header'
      );


      if (!drawer) return;


      drawer
        .querySelectorAll(
          'mobile-sliderule.ss-accordion-open'
        )
        .forEach(function (sliderule) {

          sliderule.classList.remove(
            'ss-accordion-open'
          );

        });


      drawer
        .querySelectorAll(
          '.ss-accordion-hidden'
        )
        .forEach(function (item) {

          item.classList.remove(
            'ss-accordion-hidden'
          );

        });


      drawer
        .querySelectorAll(
          '[data-sliderule-open][aria-expanded="true"]'
        )
        .forEach(function (trigger) {

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );

          trigger.classList.remove(
            'ss-arrow-open'
          );

        });

    },
    false
  );

});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
